import { NumberAugmentation } from './number-augmentation';
import { StringAugmentation } from './string-augmentation';
import { ArrayAugmentation } from './array-augmentation';
export class Augmentations {
  static init() {
    NumberAugmentation.init();
    StringAugmentation.init();
    ArrayAugmentation.init();
  }
}
